export default {
  navBar: {
    phone: 'Phone: 400-852-6298',
    chinese: '中文',
    english: 'English',
    brandName: 'LEVIY GLOBAL',
    brandSubtitle: 'LEGAL & BUSINESS SERVICES',
    home: 'Home',
    businessServices: 'Business Services',
    legalServices: 'Legal Services',
    knowledge: 'Knowledge',
    about: 'About Us',
    contact: 'Contact Us',
  },
  hero: {
    tagline: 'Focused on cross-border services, integrating law, finance and business to escort enterprises going global',
    consultNow: 'Consult Now',
    learnMore: 'Learn More',
  },
  stats: {
    '0': {
      title: '20+ Years Experience',
      description: 'Over 20 years in cross-border services services, serving 100+ enterprises',
    },
    '1': {
      title: 'Global Network',
      description: 'Service network covering 50+ countries and regions',
    },
    '2': {
      title: 'Professional & Reliable',
      description: 'Professional legal, tax, and business team ensuring quality service',
    },
    '3': {
      title: 'One-Stop Service',
      description: 'Full-process service from company registration to operation management',
    },
  },
  sideBar: {
    phone: 'Contact Phone',
    email: 'Email Consultation',
    wechat: 'WeChat Consultation',
    wechatScan: 'Scan for WeChat Consultation',
  },
  footer: {
    address: 'Room 1101, 11F, Metro Business Building, No.611 Zhongshan North Road, Gongshu District, Hangzhou, Zhejiang, China',
    coreServices: 'Core Services',
    copyright: '© 2026 LEVIY GLOBAL. All rights reserved.',
    friendlyLinks: 'Friendly Links',
    hkRegistration: 'HK Company Registration',
    offshoreRegistration: 'Offshore Registration',
    odiInvestment: 'ODI Overseas Investment',
    vieStructure: 'VIE Structure',
    companyRegistration: 'Company Registration & Management',
    banking: 'Bank Account',
    accounting: 'Accounting & Audit',
    companySearch: 'Company Search',
    crossBorderInvestment: 'Cross-border Investment',
    taxPlanning: 'International Tax Planning',
    internationalSolutions: 'International Business Solutions',
    legalOpinion: 'Legal Verification',
    legalOpinionFull: 'Legal Verification & Opinion',
    notarization: 'Overseas Notarization',
    notarizationFull: 'Overseas Notarization',
    dueDiligence: 'Due Diligence',
    contractDrafting: 'Contract Drafting & Review',
    contractDraftingFull: 'Contract Drafting & Review',
    propertyInvestigation: 'Property Investigation',
    arbitrationEnforcement: 'Arbitration Enforcement',
    arbitrationEnforcementFull: 'Arbitration Enforcement',
    generalLegal: 'General Legal Services',
    // 友情链接
    friendlyLink1: '中国投资指南（商务部）',
    friendlyLink2: '中国国际贸易促进委员会',
    friendlyLink3: '国家外汇管理局',
    friendlyLink4: 'LinkedIn',
    friendlyLink5: '世界知识产权组织',
    friendlyLink6: '美国专利商标局',
  },
}
